import(/* webpackMode: "eager" */ "/app/src/app/(main)/blog/page.tsx");
